import {
  DEFAULT_ENSEMBLE_TURN_ENGINES,
  DEFAULT_ENSEMBLE_WORD_ENGINES,
  type TEnsembleRole,
  validateEngineList,
} from "@lexicanon/shared"

/**
 * Parse a stored JSON engine-list setting, falling back to the hardcoded floor
 * when the value is missing or fails validateEngineList.
 */
export function parseEngineSetting(role: TEnsembleRole, raw: string | undefined): string[] {
  const floor = role === "words" ? DEFAULT_ENSEMBLE_WORD_ENGINES : DEFAULT_ENSEMBLE_TURN_ENGINES
  if (!raw) return [...floor]
  const parsed = validateEngineList(role, raw)
  if (parsed.ok) return [...parsed.engines]
  return [...floor]
}
